<template>
	<div class="alarm-circle" :type="type">
		<span class="alarm-content"><slot /></span>
	</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "AlarmCircle",

	props: {
		type: {
			type: String,
			default: () => "error",

			validator(value: string) {
				return ["success", "error", "inProgress", "warning"].includes(value);
			}
		}
	}
});
</script>
<style lang="scss">
$content-color: #fff; // this is always white in any theme
$height: 36px;
$width: 36px;
$types: (
	"success": var(--dashboard-success),
	"error": var(--dashboard-danger),
	"warning": var(--dashboard-warning),
	"inProgress": var(--dashboard-primary)
);

div.alarm-circle {
	border-radius: 50%;
	font-family: var(--number-font);
	color: $content-color;
	height: $height;
	width: $width;
	margin: 8px;

	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 32px;
	font-weight: 600;

	@each $type, $color in $types {
		&[type="#{$type}"] {
			background-color: $color;
			// &:after,
			&:before {
				background-color: $color;
			}
		}
	}

	> span.alarm-content {
		z-index: 6;
	}
	// &:after,
	&:before {
		content: "";
		position: absolute;
		border-radius: 50%;
		z-index: 5;
	}
	// &:after {
	// 	width: 44px;
	// 	height: 44px;
	// 	opacity: 50%;
	// }
	&:before {
		width: 36px;
		height: 36px;
		animation: pulse-ring 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
	}
}

@keyframes pulse-ring {
	0% {
		transform: scale(1.2);
	}
	80%,
	100% {
		opacity: 0;
		transform: scale(1.6);
	}
}
</style>
